module.exports = __webpack_public_path__ + "img/error.8cf82d32.png";